import React, { VoidFunctionComponent } from "react";
import { RatingBar } from "@/components/responsive/product/layer/rating/RatingBar";
import { DisplayStars } from '@/components/responsive/product/seller/DisplayStars';
import { ProductReviewListStatistics } from "@/models/scope/productSheet/reviews/ProductReviewListStatistics";
import Utils from "@/libs/Utils";

export const RatingDetails: VoidFunctionComponent<{
    reviewListStatistics: ProductReviewListStatistics
}> = ({ reviewListStatistics }) => {

    const { rateAverage, total, countsByRate } = reviewListStatistics;
    const rateDisplayed = rateAverage ? rateAverage.replace('.', ',') : null;

    const renderRatingBarContainer = (note: string) => {
        const count = countsByRate[note];
        return (
            <div className='rating-bar-container' key={note}>
                <div className='note'>
                    <p>{note}</p>
                    <img src={"/assets/images/responsive/icons/star-fill.svg"} />
                </div>
                <RatingBar count={String(count)} totalCount={total || '0'} />
                <div className='count'>{count}</div>
            </div>
        );
    };
    const renderHeader = () => {
        return (
            <div className='header'>
                <div className='text'>
                    {rateDisplayed && <p className='notation'>{Utils.getDecimalFormat(
                        rateAverage)}/5</p>}
                    <p className='number-of-review'>{total || 0} avis</p>
                </div>
                <div className='rating-stars'>
                    <DisplayStars score={rateAverage} />
                </div>
            </div>
        );
    };
    return (
        <div className='rating-details'>
            {renderHeader()}
            <div className='counts-by-rate'>
                {Object.keys(countsByRate).map((note) =>
                    renderRatingBarContainer(note),
                )}
            </div>
        </div>
    );
};